import React from 'react';
import { useApp } from '../../context/AppContext';

const Ticker = () => {
    const { articles, settings } = useApp();
    const breakingArticles = articles.filter(a => a.breaking === 'yes' && a.status === 'live');

    if (settings.ticker === 'off' || breakingArticles.length === 0) return null;

    return (
        <div id="ticker" style={{ background: 'var(--ticker-bg, #CC0000)', color: '#fff', display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
            <div style={{ background: '#000', fontFamily: 'var(--ff-label)', letterSpacing: '2px', padding: '8px 16px', whiteSpace: 'nowrap', fontSize: '14px', flexShrink: 0 }}>⚡ BREAKING</div>
            <div style={{ flex: 1, overflow: 'hidden', height: '36px', display: 'flex', alignItems: 'center' }}>
                <div style={{ whiteSpace: 'nowrap', animation: 'tickerMove 35s linear infinite', fontSize: '13px', fontWeight: '600' }}>
                    {breakingArticles.map((article, idx) => (
                        <span key={idx} style={{ margin: '0 40px' }}>🔴 {article.title}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Ticker;